import type { SVGProps } from 'react';

const SvgAnnotationDeActivate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m13.54 4.01-.73-.66c-.58-.52-1.49-.46-1.99.14l-3 4.44c-.37-.07-.76-.09-1.16-.03-1.79.3-1.69 1.46-1.4 3.25 0 0-3.29-1.11-3.25.85.32 1.94 2.48 2.92 5.07 2.49 1.79-.3 3.65-2.09 3.35-3.88-.05-.32-.16-.61-.3-.89l3.38-3.6c.65-.54.66-1.54.03-2.1zM16 17c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l3.29-3.29-3.29-3.29a.996.996 0 1 1 1.41-1.41l4 4c.39.39.39 1.02 0 1.41l-4 4c-.2.2-.45.29-.71.29z"
    />
  </svg>
);
export default SvgAnnotationDeActivate;
